import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { externalAuth, type ExternalBinding, type ExternalIntent, type ExternalProvider } from '@/services/externalAuth';
import ExternalAuthFlow from '../auth/components/ExternalAuthFlow';

const names: Record<ExternalProvider, string> = { x: 'X', telegram: 'Telegram', apple: 'Apple' };
export default function ExternalIdentityCard({ provider }: { provider: ExternalProvider }) {
  const { accessToken } = useAuth();
  const [binding, setBinding] = useState<ExternalBinding | null>(null);
  const [intent, setIntent] = useState<ExternalIntent | null>(null);
  const [email, setEmail] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [error, setError] = useState('');
  const refresh = useCallback(async () => {
    if (!accessToken) return;
    try { setBinding(await externalAuth.binding(provider, accessToken)); setError(''); }
    catch { setError('暂时无法读取绑定状态'); }
  }, [accessToken, provider]);
  useEffect(() => { void refresh(); }, [refresh]);
  const label = names[provider];
  function closeFlow() { setIntent(null); setConfirm(false); setEmail(''); void refresh(); }
  return <section className="rounded-2xl bg-white p-4 shadow-sm" aria-label={`${label} 登录管理`}>
    <h2 className="font-bold text-gray-900">{label} 登录</h2>
    {error && <p role="alert" className="mt-2 text-sm text-red-600">{error}</p>}
    <p className="mt-2 text-sm text-gray-600">{binding?.provider_revocation === 'pending' ? '授权撤销处理中'
      : binding?.bound ? `已绑定 · ${binding.email_masked || '平台账号'}` : binding ? '未绑定' : '正在读取…'}</p>
    {binding && binding.provider_revocation !== 'pending' && <button type="button" className="mt-2 min-h-11 text-indigo-600"
      onClick={() => { setConfirm(true); setEmail(''); }}>
      {binding.bound ? '解除绑定' : `绑定 ${label}`}
    </button>}
    {confirm && <div className="mt-3 space-y-3">
      <p className="text-sm text-gray-600">{binding?.bound ? '请输入原平台账号邮箱以继续解绑；隐藏邮箱还需先用另一已绑定方式重新登录。' : '请输入原平台账号邮箱以验证账号归属。'}</p>
      <input type="email" autoComplete="email" aria-label="原平台账号邮箱" value={email} onChange={event => setEmail(event.target.value)}
        className="h-12 w-full rounded-xl border px-3" />
      <div className="flex gap-4">
        <button type="button" className="min-h-11 text-gray-600" onClick={() => setConfirm(false)}>取消</button>
        <button type="button" disabled={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())} className="min-h-11 text-indigo-600 disabled:text-gray-400"
          onClick={() => { setIntent(binding?.bound ? 'unlink' : 'bind'); setConfirm(false); }}>继续验证</button>
      </div>
    </div>}
    {intent && <ExternalAuthFlow provider={provider} intent={intent} email={email.trim()} onClose={closeFlow} onSuccess={closeFlow} />}
  </section>;
}
